export default "__VITE_ASSET__T8evXTcg__"